export default __webpack_public_path__ + "static/media/login.055780a8.svg";